/* MUI */
import { NavigateBefore } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const PageNotFound = () => {
    const { t } = useTranslation();
    return (
        <Box
            textAlign="center"
            height="100vh"
            sx={{ backgroundColor: 'background.pageNotFound' }}
            paddingTop="128px"
        >
            <Box
                marginBottom="32px"
                mx="auto"
                border="4px solid"
                borderColor="border.pageNotFound"
                height="90px"
                width="90px"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="h1" color="text.pageNotFound">
                    404
                </Typography>
            </Box>
            <Typography
                variant="h1"
                marginBottom="64px"
                color="text.pageNotFound"
            >
                {t('ErrorPage.oops')}
            </Typography>
            <Link
                to="/home"
                style={{
                    alignItems: 'center',
                    display: 'inline-flex',
                    fontSize: '20px'
                }}
                data-trackid="pageNotFound_home_routeTo"
            >
                <NavigateBefore
                    sx={{ color: 'text.pageNotFound', marginTop: '2px' }}
                />
                <Box color="text.pageNotFound">{t('ErrorPage.goHome')}</Box>
            </Link>
        </Box>
    );
};
